/** @jsxImportSource @emotion/react */
import React from 'react';
import {
  LocalHospital as HealthcareIcon,
  School as EducationIcon,
  Public as ImmigrationIcon,
  Security as GunControlIcon,
  Favorite as RacialEqualityIcon,
  WbSunny as ClimateIcon,
  Gavel as JusticeIcon,
  AttachMoney as PovertyIcon,
  HowToVote as VotingIcon,
  RecordVoiceOver as SpeechIcon,
  Work as WorkersIcon,
  Church as ReligiousIcon,
  LocalPharmacy as DrugIcon,
  People as HumanRightsIcon,
  Pets as AnimalRightsIcon,
  Forum as GeneralIcon,
  Favorite as FavoriteIcon,
  Psychology as PsychologyIcon,
} from '@mui/icons-material';

export interface CauseInfo {
  id: string;
  name: string;
  icon: React.ReactNode;
  color: string;
}

export const CAUSES: CauseInfo[] = [
  { id: 'general', name: 'General', icon: <GeneralIcon />, color: '#757575' },
  { id: 'abortion', name: 'Abortion', icon: <HealthcareIcon />, color: '#E53935' },
  { id: 'gun-control', name: 'Gun Control', icon: <GunControlIcon />, color: '#D81B60' },
  { id: 'racial-equality', name: 'Racial Equality', icon: <RacialEqualityIcon />, color: '#8E24AA' },
  { id: 'lgbtq', name: 'LGBTQ+', icon: <FavoriteIcon />, color: '#5E35B1' },
  { id: 'climate-change', name: 'Climate Change', icon: <ClimateIcon />, color: '#43A047' },
  { id: 'healthcare', name: 'Healthcare', icon: <HealthcareIcon />, color: '#00897B' },
  { id: 'immigration', name: 'Immigration', icon: <ImmigrationIcon />, color: '#3949AB' },
  { id: 'criminal-justice', name: 'Criminal Justice Reform', icon: <JusticeIcon />, color: '#1565C0' },
  { id: 'poverty', name: 'Poverty & Economic Justice', icon: <PovertyIcon />, color: '#0277BD' },
  { id: 'voting', name: 'Voting', icon: <VotingIcon />, color: '#00838F' },
  { id: 'speech', name: 'Freedom of Speech', icon: <SpeechIcon />, color: '#00695C' },
  { id: 'education', name: 'Education Reform', icon: <EducationIcon />, color: '#2E7D32' },
  { id: 'mental-health', name: 'Mental Health', icon: <PsychologyIcon />, color: '#558B2F' },
  { id: 'workers', name: "Workers' Rights", icon: <WorkersIcon />, color: '#827717' },
  { id: 'religious', name: 'Religious Freedom', icon: <ReligiousIcon />, color: '#EF6C00' },
  { id: 'drug', name: 'Drug Legalization', icon: <DrugIcon />, color: '#D84315' },
  { id: 'human-rights', name: 'Human Rights & Equality', icon: <HumanRightsIcon />, color: '#607D8B' },
  { id: 'animal-rights', name: 'Animal Rights', icon: <AnimalRightsIcon />, color: '#546E7A' },
]; 